export default __webpack_public_path__ + "static/media/bubos.456af2c1.flac";